export default function GeoMarkersOverlay() {
    return (
        <div className="map-overlay map-overlay-geomarkers">
            <div className="geomarkers-map-legend-div">
                <div className="start-geomarker-legend-div">
                    <div className="start-geomarker-color" />
                    <span className="start-geomarker-label"> - точка закрепления начала дороги</span>
                </div>
                <div className="end-geomarker-legend-div">
                    <div className="end-geomarker-color" />
                    <span className="end-geomarker-label">  - точка закрепления конца дороги</span>
                </div>
            </div>
        </div>
    )
}
